import React from "react";

export const VIEWING_EXPERIENCES_HEADER_TEXT = (locationName: string) =>
  `Viewing activities in ${locationName}`;

export const DATELESS_HEADER_TEXT = (locationName: string) =>
  `Explore activities in ${locationName}`;

export const DATELESS_BANNER_TEXT =
  "To check availability and book an activity, select dates";

export const DATELESS_BANNER_CTA = "Select dates";

export const EARN_ENHANCEMENT_SUBTITLE = (
  earnRate: string | number,
  productDisplayName: string,
  currency: string
) => {
  const multiplier = currency.includes("cash") ? "%" : "X";
  return (
    <>
      <span className="font-bold">
        Earn {earnRate}
        {multiplier} {currency}
      </span>{" "}
      on activities with your ${productDisplayName} account.
    </>
  );
};

/**
 * @deprecated Use getEarnTag from the common module instead.
 * This function returns a string with HTML markup which is not safe.
 * The getEarnTag function provides a safer alternative using JSX.
 */
export const getEarnTagText = (earnRate: string | number, currency: string) => {
  const multiplier = currency.includes("cash") ? "%" : "X";
  return `<span><b>Earn ${earnRate}${multiplier}</b> ${currency} on activities</span>`;
};

export const FETCH_AVAILABILITY_TEXT = "for activities";

export const SEARCH_TITLE = (location: string | undefined) =>
  location
    ? `Explore activities in ${location.split(",")[0]}`
    : `Explore activities`;

export const NO_RESULTS_TITLE = "No activities found";
export const NO_RESULTS_SUBTITLE =
  "Please try adjusting filters to view available activities.";

export const CLEAR_ALL_FILTERS = "Clear all filters";

// data-testid selector for the desktop date picker (used by the dateless banner CTA).
export const DESKTOP_DATE_PICKER_SELECTOR = '[data-testid="desktop-date-picker"]';


// Analytics event names
export const ACTIVITIES_VIEW_TOGGLE = "activities_view_toggle";
